import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

export default function Clientes() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [clientes, setClientes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    API.get('/clientes').then(res => {
      setClientes(res.data);
      setCargando(false);
    }).catch(() => setCargando(false));
  };

  const clientesFiltrados = busqueda
    ? clientes.filter(c => c.nombre.toLowerCase().includes(busqueda.toLowerCase()) || c.email?.toLowerCase().includes(busqueda.toLowerCase()))
    : clientes;

  if (cargando) return <div style={s.loading}>Cargando...</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <div style={s.topbarTitle}>Clientes</div>
        <div style={s.topbarActions}>
          <input style={s.searchInput} placeholder="Buscar cliente..." value={busqueda} onChange={e => setBusqueda(e.target.value)} />
          {usuario?.rol === 'admin' && (
            <button style={s.btn} onClick={() => navigate('/clientes/nuevo')}>+ Nuevo cliente</button>
          )}
        </div>
      </div>

      <div style={s.content}>
        <div style={s.resumen}>
          <div style={s.resumenItem}><span style={s.resumenNum}>{clientes.length}</span><span style={s.resumenLabel}>Clientes</span></div>
        </div>

        {clientesFiltrados.length === 0 ? (
          <div style={s.empty}>
            <div style={s.emptyText}>{busqueda ? 'Sin resultados' : 'No hay clientes aún'}</div>
            {!busqueda && usuario?.rol === 'admin' && <button style={s.btn} onClick={() => navigate('/clientes/nuevo')}>Añadir primer cliente</button>}
          </div>
        ) : (
          <div style={s.card}>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Cliente</th>
                  <th style={s.th}>Contacto</th>
                  <th style={s.th}>Email</th>
                  <th style={s.th}>Teléfono</th>
                  <th style={s.th}>CIF</th>
                </tr>
              </thead>
              <tbody>
                {clientesFiltrados.map(c => (
                  <tr key={c.id} style={s.tr} onClick={() => navigate(`/clientes/${c.id}`)}
                    onMouseEnter={e => e.currentTarget.style.background='#fafaf8'}
                    onMouseLeave={e => e.currentTarget.style.background='white'}>
                    <td style={s.td}><span style={s.nombre}>{c.nombre}</span></td>
                    <td style={s.td}><span style={s.muted}>{c.contacto || '—'}</span></td>
                    <td style={s.td}><span style={s.muted}>{c.email || '—'}</span></td>
                    <td style={s.td}><span style={s.muted}>{c.telefono || '—'}</span></td>
                    <td style={s.td}><span style={s.muted}>{c.cif || '—'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#aaa', fontSize:14 },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center', justifyContent:'space-between' },
  topbarTitle: { fontSize:14, fontWeight:500, color:'#1a1a1a' },
  topbarActions: { display:'flex', gap:10, alignItems:'center' },
  searchInput: { padding:'7px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:13, outline:'none', width:200 },
  content: { padding:24, display:'flex', flexDirection:'column', gap:16 },
  resumen: { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12 },
  resumenItem: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:10, padding:'12px 16px', display:'flex', flexDirection:'column', gap:2 },
  resumenNum: { fontSize:22, fontWeight:600, color:'#1a1a1a' },
  resumenLabel: { fontSize:11, color:'#aaa', textTransform:'uppercase', letterSpacing:'0.05em' },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, overflow:'hidden' },
  table: { width:'100%', borderCollapse:'collapse' },
  th: { padding:'10px 16px', fontSize:11, fontWeight:500, color:'#aaa', textAlign:'left', borderBottom:'0.5px solid #f0f0ed', textTransform:'uppercase', letterSpacing:'0.05em' },
  tr: { borderBottom:'0.5px solid #f0f0ed', cursor:'pointer', background:'white' },
  td: { padding:'12px 16px', fontSize:13, color:'#1a1a1a', verticalAlign:'middle' },
  nombre: { fontWeight:500 },
  muted: { color:'#888' },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:500, cursor:'pointer' },
  empty: { textAlign:'center', padding:'64px 0', display:'flex', flexDirection:'column', alignItems:'center', gap:16 },
  emptyText: { fontSize:14, color:'#aaa' },
};
